import i18n from "../../i18next";

export type OutgoingWireTransferStateType = "COMPLETED" | "PENDING_CHALLENGE" | "SUBMITTED" | "REJECTED" | "APPROVED" | "FAILED";
export default function getOutgoingWireTransferStatusName(status: OutgoingWireTransferStateType) {
  return i18n.t(`dashboard.payments.overview.header_component.bottom_tabs_content.outgoing_transactions.list.states.${status}`);
}
